import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { AttributionLift } from '../../../../../../shared/types';

type GetAppAttributionLiftActionPayload = AttributionLift;

const GET_APP_ATTRIBUTION_LIFT_NAMESPACE = 'GET_APP_ATTRIBUTION_LIFT' as const;

const GetAppAttributionLift = new ReduxAsyncAction<
  typeof GET_APP_ATTRIBUTION_LIFT_NAMESPACE,
  void,
  GetAppAttributionLiftActionPayload
>(GET_APP_ATTRIBUTION_LIFT_NAMESPACE);

GetAppAttributionLift.registerRequest(function () {
  return dash_api.get('/v1/app/attribution/lift').then((res) => {
    return res.data;
  });
});

export const GET_APP_ATTRIBUTION_LIFT = GetAppAttributionLift.actionNamespaceConstants;

export const getAppAttributionLift = GetAppAttributionLift.request;

export type GetAppAttributionLiftResponseAction = DataAction<
  typeof GET_APP_ATTRIBUTION_LIFT.response,
  GetAppAttributionLiftActionPayload
>;
